/** Package constants organized in a plain object. */
export const Constants = {
  KeyMimicClick: 'Enter',
  AuthNotInitialized: 'Auth adapter not initialized' // Error message for uninitialized auth adapter.
} as const;
